import { setAppType } from "@funded-here-interface/common/src/constant/appType";

import "@mantine/core/styles.css";
import "mantine-react-table/styles.css";
import { MantineProvider } from "@mantine/core";
import { emotionTransform, MantineEmotionProvider } from "@mantine/emotion";

import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

setAppType("investor");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <MantineProvider stylesTransform={emotionTransform}>
      <MantineEmotionProvider>
        <App />
      </MantineEmotionProvider>
    </MantineProvider>
  </React.StrictMode>,
);
